import { z } from 'zod';

const identitySchema = z.looseObject({ sub: z.string().min(1), email: z.string() });

/** Argument of the `submitDecision` update. NOT implemented by autopilot yet (future feature). */
export const submitDecisionUpdateInputSchema = z.looseObject({
  decisionId: z.string().min(1),
  outcome: z.string().min(1),
  reason: z.string(),
  payload: z.record(z.string(), z.unknown()).optional(),
  decidedBy: identitySchema,
});
export type SubmitDecisionUpdateInput = z.infer<typeof submitDecisionUpdateInputSchema>;

export const submitDecisionUpdateResultSchema = z.looseObject({
  accepted: z.boolean(),
  stage: z.string().nullable(),
});
export type SubmitDecisionUpdateResult = z.infer<typeof submitDecisionUpdateResultSchema>;

/** PROVISIONAL: argument of the `requestCancel` signal. */
export const requestCancelSignalInputSchema = z.looseObject({
  reason: z.string(),
  requestedBy: identitySchema,
});
export type RequestCancelSignalInput = z.infer<typeof requestCancelSignalInputSchema>;
